import { render } from "./KontaktiView.vue?vue&type=template&id=52bdc7da"
import script from "./KontaktiView.vue?vue&type=script&lang=js"
export * from "./KontaktiView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__